<template>
  <div>
    <Header :title="title" :showBack="isShowBack"></Header>
    <div class="LineClassListDetail">
      <div class="header">
        <span>{{ sendCarTime }}</span>
        <span>{{ LineName }}</span>
      </div>

      <van-tabs v-model="active" color="#2891e7">
        <van-tab title="班次上车点">
          <!-- 上车点统计 -->
          <div class="Node">
            <div class="NodeTotal">
              <div class="title">
                上车点统计
                <van-switch style="z-index: 0" active-color="#ccc" size=".44rem" v-model="startNodeTotalSwitch" />
              </div>
              <div>
                <van-row>
                 <van-col span="12">
                 <van-cell
                  is-link
                  :title="selectStartNodeGroup"
                  @click="startNodeShow = true"
                  style="padding: 0.1rem 0.2rem; background-color:#ccc"
                 /></van-col>
                </van-row>
              </div>
              <div v-if="startNodeTotalSwitch" class="content">
                <div class="wrap" v-for="(item, index) of startNodeList" :key="item.id">
                  <div class="node" style="position: relative">
                    <div class="isCanSale" v-if="!item.IsCanSale">停</div>
                    <span>
                      {{ item.NodeName }}
                    </span>
                    <span :class="{ current: item.isSaleArr }" @click="saleBtnClick(item, index)">售：{{
                        item.startSaleArr ? item.startSaleArr.length : 0
                    }}</span>
                    <span :class="{ current: item.isCheckArr }" @click="checkBtnClick(item, index)">检：{{
                        item.startCheckArr ? item.startCheckArr.length : 0
                    }}</span>
                    <span @click="changeStartNodeListBtnClick(item)" class="btn">
                      <button>修改</button>
                    </span>
                    <span @click="sendCar(item)" class="btn">
                      <button>发车</button>
                    </span>
                  </div>
                  <div v-if="item.isSaleArr || item.isCheckArr" class="detailHeader">
                    <span>上车点</span>
                    <span>乘客</span>
                    <span>操作</span>
                  </div>

                  <div v-if="item.isSaleDetails" class="detail">
                    <div v-for="saleItem of item.startSaleArr" :key="saleItem.id">
                      <span>{{ saleItem.StartNodeName }}</span>
                      <span>
                        {{ saleItem.CustName }}
                        <a :href="'tel:' + saleItem.CustTel">{{
                            saleItem.CustTel
                        }}</a>
                      </span>
                      <span>{{ saleItem.StatusName }}</span>
                    </div>
                    <div :class="{ noData: item.startSaleArr.length < 1 }" v-if="item.startSaleArr.length < 1">
                      暂无数据
                    </div>
                    <div @click="closedBtnClick(item, index, '售')" :class="{ closed: item.isSaleArr }">
                      <span>收起</span>
                    </div>
                  </div>
                  <div v-if="item.isCheckDetails" class="detail checkDetail">
                    <div v-for="checkItem of item.startCheckArr" :key="checkItem.id">
                      <span>{{ checkItem.StartNodeName }}</span>
                      <span>
                        {{ checkItem.CustName }}
                        <a :href="'tel:' + checkItem.CustTel">{{
                            checkItem.CustTel
                        }}</a>
                      </span>
                      <span>{{ checkItem.StatusName }}</span>
                    </div>
                    <div :class="{ noData: item.startCheckArr.length < 1 }" v-if="item.startCheckArr.length < 1">
                      暂无数据
                    </div>
                    <div :class="{ closed: item.isCheckArr }">
                      <span @click="closedBtnClick(item, index, '检')">收起</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="班次下车点">
          <!-- 下车点统计 -->
          <div class="Node">
            <div class="NodeTotal ArrivalNode">
              <div class="title">
                下车点统计
                <van-switch style="z-index: 0" active-color="#ccc" size=".44rem" v-model="arrivalNodeTotalSwitch" />
              </div>
              <div>
                <van-row>
                <van-col span="12">
                  <van-cell
                    is-link
                    :title="selectArrivalNodeGroup"
                    @click="arrivalNodeShow = true"
                    style="padding: 0.1rem 0.2rem; background-color:#ccc"
                /></van-col>
                 </van-row>
              </div>
              <div v-if="arrivalNodeTotalSwitch" class="content">
                <div class="wrap" v-for="(item, index) of arrivalNodeList" :key="item.id">
                  <div class="node" style="position: relative">
                    <div class="isCanSale" v-if="!item.IsCanSale" style="left: 2.9rem;">停</div>
                    <span style="width: 30%">{{ item.NodeName }}</span>
                    <span :class="{ current: item.isDownArr }" @click="downNumBtnClick(item, index)">下车人数：{{
                        item.DownNum
                    }}</span>
                    <span @click="changeAiivalNodeListBtnClick(item)" class="btn">
                      <button>修改</button>
                    </span>
                  </div>
                  <div v-if="item.isDownDetails" class="detailHeader">
                    <span>下车点</span>
                    <span>乘客</span>
                    <span>操作</span>
                  </div>

                  <div v-if="item.isDownDetails" class="detail">
                    <div v-for="DownNumItem of item.arrivalDownNumArr" :key="DownNumItem.id">
                      <span>{{ DownNumItem.StartNodeName }}</span>
                      <span>{{ DownNumItem.CustName }}</span>
                      <span>下</span>
                    </div>
                    <div :class="{ noData: item.arrivalDownNumArr.length < 1 }"
                      v-if="item.arrivalDownNumArr.length < 1">
                      暂无数据
                    </div>
                    <div :class="{ closed: item.isDownArr }">
                      <span @click="closedBtnClick(item, index, '下')">收起</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <!-- 班次售检明细 -->
      <van-tabs v-model="saleCheckActive" color="#2891e7">
        <van-tab class="ClassDetail" title="售票明细">
          <div v-if="ticketOrderDetailList && ticketOrderDetailList.length > 0" class="detail">
            <div class="title">
              <span>乘客</span>
              <span>上车点→下车点</span>
              <span>状态</span>
              <span>操作</span>
            </div>
            <div class="content">
              <div v-for="item of ticketOrderDetailList" :key="item.id" class="wrap">
                <span>
                  {{ item.CustName }}
                  <br />
                  <a :href="'tel:' + item.CustTel">{{ item.CustTel }}</a>
                  渠道:{{ item.AgentName }}
                </span>
                <span>{{ item.StartNodeName }} → {{ item.ArrivalNodeName }}</span>
                <span>{{ item.StatusName }}</span>
                <span>
                  <van-tag type="success" color="green" text-color="white" @click="onCheckTicket(item)">检票</van-tag>
                  <van-tag type="danger" color="#ffe1e1" text-color="#ad0000" style="margin-top: 10px"
                    @click="onBackTicket(item)">退票</van-tag>
                </span>
              </div>
            </div>
          </div>
          <div v-else>暂无数据</div>
        </van-tab>
        <van-tab class="ClassDetail" title="检票明细">
          <div v-if="ticketCheckDetailList && ticketCheckDetailList.length > 0" class="detail">
            <div class="title">
              <span>乘客</span>
              <span>上车点→下车点</span>
              <span>状态</span>
              <span>操作</span>
            </div>
            <div class="content">
              <div v-for="item of ticketCheckDetailList" :key="item.id" class="wrap">
                <span>
                  {{ item.CustName }}
                  <br />
                  <a :href="'tel:' + item.CustTel">{{ item.CustTel }}</a>
                  渠道:{{ item.AgentName }}
                </span>
                <span>{{ item.StartNodeName }} → {{ item.ArrivalNodeName }}</span>
                <span>{{ item.StatusName }}</span>
                <span>
                  <van-tag type="success" color="blue" text-color="white" @click="onBackCheckTicket(item)">退检</van-tag>
                  <van-tag type="danger" color="#ffe1e1" text-color="#ad0000" style="margin-top: 10px"
                    @click="onBackTicket(item)">退票</van-tag>
                </span>
              </div>
            </div>
          </div>
          <div v-else>暂无数据</div>
        </van-tab>
      </van-tabs>

      <!-- 修改上车点明细 -->
      <van-popup class="isChangeNodeListPopup" v-model="isChangeStartNodeListPopup">
        <div class="header">修改上车点信息</div>
        <div class="wrap">
          <div class="row">
            <span>上车点：</span>
            <span>{{ changeInfoList.NodeName }}</span>
          </div>
          <div class="row">
            <span>公司名称：</span>
            <span>{{ changeInfoList.CompFullNameAndNickName }}</span>
          </div>
          <div class="row">
            <span>发车时间：</span>
            <span>
              <input type="text" v-model="changeInfoList.ClassTime" />
            </span>
          </div>
          <div class="row">
            <span>始发站点：</span>
            <span>{{ changeInfoList.IsStartNode == 1 ? "是" : "否" }}</span>
          </div>
          <div class="row">
            <span>是否可售：</span>
            <span>
              <input type="checkbox" v-model="changeInfoList.IsCanSale" />
            </span>
          </div>
          <div class="row">
            <span>站点电话：</span>
            <span>
              <input type="text" v-model="changeInfoList.NodeTel" />
            </span>
          </div>
          <div class="row">
            <span>车位：</span>
            <span>
              <input type="text" />
            </span>
          </div>
          <div class="row">
            <span>检票口：</span>
            <span>
              <input type="text" />
            </span>
          </div>
          <div class="row">
            <span>候车区：</span>
            <span>
              <input type="text" />
            </span>
          </div>
          <div class="row">
            <span>已售票数：</span>
            <span>{{ changeInfoList.SaleCount }}</span>
          </div>
          <div class="row">
            <span>已订票数：</span>
            <span>{{ changeInfoList.BookTicketCount }}</span>
          </div>
          <div class="row">
            <span>已检票数：</span>
            <span>{{ changeInfoList.CheckedTickets }}</span>
          </div>
          <div class="row">
            <span>是否可代售：</span>
            <span>
              <input type="checkbox" v-model="changeInfoList.IsCanAgent" />
            </span>
          </div>
          <div class="row">
            <span>是否允许检票：</span>
            <span>
              <input type="checkbox" v-model="changeInfoList.IsAllowCheck" />
            </span>
          </div>
          <div class="row">
            <span>备注：</span>
            <span>
              <input type="text" v-model="changeInfoList.Remark" />
            </span>
          </div>
          <div class="row">
            <span>创建人代码：</span>
            <span>{{ changeInfoList.CreateCode }}</span>
          </div>
          <div class="row">
            <span>创建人姓名：</span>
            <span>{{ changeInfoList.CreateName }}</span>
          </div>
          <div class="row">
            <span>创建时间：</span>
            <span>{{ changeInfoList.CreateTime }}</span>
          </div>
          <div class="row">
            <span>修改人代码：</span>
            <span>{{ changeInfoList.ModifyCode }}</span>
          </div>
          <div class="row">
            <span>修改人姓名：</span>
            <span>{{ changeInfoList.ModifyName }}</span>
          </div>
          <div class="row">
            <span>修改时间：</span>
            <span>{{ changeInfoList.ModifyTime }}</span>
          </div>
        </div>
        <div class="btn">
          <div @click="confirmChangeStartNodeList" class="confirm">确定</div>
          <div @click="cancelChangeStartNodeList" class="cancel">取消</div>
        </div>
      </van-popup>

      <!-- 修改下车点明细 -->
      <van-popup class="isChangeNodeListPopup" v-model="isChangeArrivalNodeListPopup">
        <div class="header">修改下车点信息</div>
        <div class="wrap">
          <div class="row">
            <span>下车点：</span>
            <span>{{ arrivalChangeInfoList.NodeName }}</span>
          </div>
          <div class="row">
            <span>是否可售：</span>
            <span>
              <input type="checkbox" v-model="arrivalChangeInfoList.IsCanSale" />
            </span>
          </div>
          <div class="row">
            <span>下车人数：</span>
            <span>{{ arrivalChangeInfoList.DownNum }}</span>
          </div>
          <div class="row">
            <span>行驶时间：</span>
            <span>{{ arrivalChangeInfoList.RunTime }}</span>
          </div>
          <div class="row">
            <span>终到站点：</span>
            <span>
              <input type="checkbox" disabled v-model="arrivalChangeInfoList.IsEndNode" />
            </span>
          </div>
          <div class="row">
            <span>是否可代售：</span>
            <span>
              <input type="checkbox" v-model="arrivalChangeInfoList.IsCanAgent" />
            </span>
          </div>
          <div class="row">
            <span>备注：</span>
            <span>
              <input type="text" v-model="arrivalChangeInfoList.Remark" />
            </span>
          </div>
          <div class="row">
            <span>创建人代码：</span>
            <span>{{ arrivalChangeInfoList.CreateCode }}</span>
          </div>
          <div class="row">
            <span>创建人姓名：</span>
            <span>{{ arrivalChangeInfoList.CreateName }}</span>
          </div>
          <div class="row">
            <span>创建时间：</span>
            <span>{{ arrivalChangeInfoList.CreateTime }}</span>
          </div>
          <div class="row">
            <span>修改人代码：</span>
            <span>{{ arrivalChangeInfoList.ModifyCode }}</span>
          </div>
          <div class="row">
            <span>修改人姓名：</span>
            <span>{{ arrivalChangeInfoList.ModifyName }}</span>
          </div>
          <div class="row">
            <span>修改时间：</span>
            <span>{{ arrivalChangeInfoList.ModifyTime }}</span>
          </div>
        </div>
        <div class="btn">
          <div @click="confirmChangeArrivalNodeList" class="confirm">确定</div>
          <div @click="cancelChangeArrivalNodeList" class="cancel">取消</div>
        </div>
      </van-popup>
    </div>

    <van-action-sheet
      v-model="startNodeShow"
      :actions="startNodeActionsGroup"
      @select="onStartNodeGroupSelect"
    />

    <van-action-sheet
      v-model="arrivalNodeShow"
      :actions="arrivalNodeActionsGroup"
      @select="onArrivalNodeGroupSelect"
    />

  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "班线详情信息", //标题
      active: 0, // 上下车点标签页
      saleCheckActive: 0, // 班次售检明细标签页
      GID:
        window.sessionStorage.getItem("LineClassDayGID") ||
        decodeURIComponent(this.$route.query.LineClassDayGID),
      sendCarTime:
        window.sessionStorage.getItem("sendCarTime") ||
        decodeURIComponent(this.$route.query.sendCarTime),
      LineName:
        window.sessionStorage.getItem("LineName") ||
        decodeURIComponent(this.$route.query.LineName),
      startNodeList: [], // 上车点列表
      arrivalNodeList: [], // 下车点列表
      isGetArrivalNode: false, // 是否有获取过下车点数据
      isGetTicketCheckDetail: false, // 是否有获取过检票明细列表数据
      ticketOrderDetailList: [], // 班线售票明细列表
      startNodeTotalSwitch: true, // 上车点统计显示状态
      arrivalNodeTotalSwitch: true, // 下车点统计显示状态
      ticketCheckDetailList: [], // 班线检票明细列表
      isChangeStartNodeListPopup: false, // 上车点列表信息修改弹窗
      changeInfoList: [], // 修改上车弹窗列表信息
      originChangeInfoList: [], // 初始化的修改上车弹窗列表信息
      isChangeArrivalNodeListPopup: false, // 下车点列表信息修改弹窗
      arrivalChangeInfoList: [], // 修改下车弹窗列表信息
      originArrivalChangeInfoList: [], // 初始化的修改下车弹窗列表信息
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象

      lineGID:
        window.sessionStorage.getItem("LineGID") ||
        decodeURIComponent(this.$route.query.LineGID),//线路GID
      startNodeShow: false,
      arrivalNodeShow: false,
      startNodeGroupList: [],
      arrivalNodeGroupList: [],
      startNodeActionsGroup: [{ name: "取消选择" }],
      arrivalNodeActionsGroup: [{ name: "取消选择" }],
      startNodeGroup: "",
      arrivalNodeGroup: "",
      selectStartNodeGroup: "点击选择上车站点分组",
      selectArrivalNodeGroup: "点击选择下车站点分组",
      // pageNumber: 1,
      // pageSize: 10,
      // total: 0,
    };
  },
  computed:{
    isShowBack(){
      return window.history.length > 1
    }
  },
  methods: {
    sendCar(item) {
      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(item)
      );
      this.$router.push({
        path: "NodeStartCar",
        query: {
          // ValuePeople: item.CheckedTickets - item.SendPeople,
          ValuePeople: item.CheckedTickets,
        },
      });
    },
    //退检
    onBackCheckTicket(item) {
      if (item.TicketStatusID != 8 && item.TicketStatusID != 9) {
        this.$toast("车票非已检状态，无法退检");
        return;
      }
      //提示是否确认退检
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "将对车票：" + item.BarCode + "进行退检操作，是否确认？",
        })
        .then(() => {
          let params = {
            AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
            BarCode: item.BarCode, //车票条码
            LineClassDayGID: item.CheckClassGID, //日班次GID
            StartNodeGID: item.CheckNodeGID, //发车点GID
            OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
            OperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode, //操作员代码
            OperName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName, //操作员名称
          };
          this.$http
            .post(this.$api.onTicketCheckUnCommit, this.$qs.stringify(params))
            .then((res) => {
              if (res.success) {
                //刷新数据
                this.$toast.success("退检成功");
                setTimeout(() => {
                  this.getTicketOrderDetail();
                }, 1000);
              } else {
                this.$toast.fail("退检失败");
              }
            });
        })
        .catch(() => { });
    },
    //检票
    onCheckTicket(item) {
      if (item.TicketStatusID != 2) {
        this.$toast("车票非已售状态，无法检票");
        return;
      }
      //提示是否确认检票
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "将对车票：" + item.BarCode + "进行正检操作，是否确认？",
        })
        .then(() => {
          let checkModeFlag = 1; //默认普通检票
          //获取是否可检之前日期的班次权限
          let isCanCheck = this.$utils.getRight(
            "CywPhone.StationManagement",
            "IsCanCheckBeforeClass"
          );
          let isBeforeDate = this.$moment(
            item.ClassDate.substring(0, 10) + " " + item.ClassTime
          ).isBefore(this.$moment(new Date()).add(-6, "h"));
          if (!isCanCheck && isBeforeDate) {
            this.$toast.fail("不可检之前日期的班次");
            return;
          }
          let params = {
            AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
            BarCode: item.BarCode, //车票条码
            LineClassDayGID: item.LineClassDayGID, //日班次GID
            StartNodeGID: item.StartNodeGID, //发车点GID
            CheckModeFlag: checkModeFlag, //是否身份证检票
            OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
            OperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode, //操作员代码
            OperName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName, //操作员名称
          };
          this.$http
            .post(this.$api.onCheckTicket, this.$qs.stringify(params))
            .then((res) => {
              if (res.success) {
                //判断是否存在返回信息
                if (res.data.TicketCheckBackMsg) {
                  alert(res.data.TicketCheckBackMsg);
                  return;
                }
                //刷新数据
                this.$toast("检票成功");
                setTimeout(() => {
                  this.getTicketOrderDetail();
                }, 1000);
              } else {
                this.$toast.fail("检票失败");
              }
            });
        })
        .catch(() => { });
    },
    onBackTicket(item) {
      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(item)
      );
      this.$router.push({
        path: "RefundTicket",
        query: {
          BarCode: item.BarCode,
        },
      });
    },
    // 获取班次上车点
    getStartNode() {
      if (this.GID) {
        let params = {
          LineClassDayGID: this.GID,
          StartNodeGroup: this.startNodeGroup,
        };
        this.$http
          .post(this.$api.getStartNode, this.$qs.stringify(params))
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.startNodeList = res.data;
              this.getTicketOrderDetail(); // 获取售票明细
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$toast("LineClassDayGID" + "为空");
      }
    },
    // 售票点击 -- 展开站点售票详情
    saleBtnClick(item, index) {
      this.screenSaleData(item, index, "售");
      this.$set(this.startNodeList[index], "isSaleArr", true);
      this.$set(this.startNodeList[index], "isCheckArr", false);
      this.$set(this.startNodeList[index], "isSaleDetails", true);
      this.$set(this.startNodeList[index], "isCheckDetails", false);
      // console.log(this.startNodeList)
    },
    // 检票点击 -- 展开站点检票详情
    checkBtnClick(item, index) {
      this.screenSaleData(item, index, "检");
      this.$set(this.startNodeList[index], "isCheckArr", true);
      this.$set(this.startNodeList[index], "isSaleArr", false);
      this.$set(this.startNodeList[index], "isCheckDetails", true);
      this.$set(this.startNodeList[index], "isSaleDetails", false);
    },
    // 修改上车点列表按钮的点击事件
    changeStartNodeListBtnClick(item) {
      this.isChangeStartNodeListPopup = true;
      this.changeInfoList = JSON.parse(JSON.stringify(item));
      this.originChangeInfoList = JSON.parse(JSON.stringify(item));
      console.log(this.changeInfoList);
    },
    // 确认修改上车点明细
    confirmChangeStartNodeList() {
      const _CompGID = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).CompGID;
      let list = JSON.parse(JSON.stringify(this.changeInfoList));
      var _jsonText = {};
      _jsonText.GID = list.GID;
      _jsonText.LineClassDayGID = list.LineClassDayGID;
      _jsonText.CompGID = list.CompGID;
      _jsonText.NodeGID = list.NodeGID;
      _jsonText.ClassTime = list.ClassTime;
      _jsonText.IsCanSale = list.IsCanSale;
      _jsonText.NodeTel = list.NodeTel;
      _jsonText.Remark = list.Remark;
      _jsonText.IsDeleted = list.IsDeleted;
      _jsonText.ModifyGID = this.OperObj.GID; //操作员GID
      _jsonText.ModifyCode = this.OperObj.UserCode; //操作员代码
      _jsonText.ModifyName = this.OperObj.UserName; //操作员名称
      _jsonText.ModifyTime = new Date();
      _jsonText.CreateGID = list.CreateGID;
      _jsonText.CreateCode = list.CreateCode;
      _jsonText.CreateName = list.CreateName;
      _jsonText.CreateTime = list.CreateTime;
      _jsonText.Berth = list.Berth;
      _jsonText.Gate = list.Gate;
      _jsonText.WaitArea = list.WaitArea;
      _jsonText.IsCanAgent = list.IsCanAgent;
      _jsonText.NodeName = list.NodeName;
      _jsonText.Geocoder = list.Geocoder;
      _jsonText.CompFullName = list.CompFullName;
      _jsonText.IsSendCar = list.IsSendCar;
      _jsonText.CheckedTickets = list.CheckedTickets;
      _jsonText.CheckedChildren = list.CheckedChildren;
      _jsonText.SaleCount = list.SaleCount;
      _jsonText.NoCeckedCount = list.NoCeckedCount;
      _jsonText.BookTicketCount = list.BookTicketCount;
      _jsonText.BookChildren = list.BookChildren;
      _jsonText.IsStartNode = list.IsStartNode;
      _jsonText.IsAllowCheck = list.IsAllowCheck;
      _jsonText._CompGID = _CompGID;
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      if (_jsonText.NodeTel && _jsonText.NodeTel.length != 11) {
        this.$toast("请输入正确的11位号码");
      } else {
        this.isChangeStartNodeListPopup = false;
        this.$http
          .post(this.$api.editLineClassDayStartNode, this.$qs.stringify(params))
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.$toast("修改成功");
              this.getStartNode();
              //this.getTicketOrderDetail();
              //this.getTicketCheckDetail();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 取消修改上车点明细
    cancelChangeStartNodeList() {
      this.isChangeStartNodeListPopup = false;
    },
    // 检索售检数据
    screenSaleData(item, index, tip) {
      let saleList = this.ticketOrderDetailList; // 售票明细数据
      let checkList = this.ticketCheckDetailList; // 检票明细数据
      if (tip == "售") {
        let startSaleArr = [];
        // this.$set(this.startNodeList[index], "startCheckArr", []); // 点击时,点击售票隐藏检票
        saleList.forEach((data) => {
          if (data.StartNodeGID == item.NodeGID && data.StatusIsValid) {
            startSaleArr.push(data);
          }
        });
        this.$set(this.startNodeList[index], "startSaleArr", startSaleArr);
        this.isSaleDetails = true;
        this.isCheckDetails = false;
      } else if (tip == "检") {
        // this.$set(this.startNodeList[index], "startSaleArr", []); // 点击检票隐藏售票
        let startCheckArr = [];
        checkList.forEach((data) => {
          if (data.StartNodeGID == item.NodeGID && data.StatusIsValid) {
            startCheckArr.push(data);
          }
        });
        this.$set(this.startNodeList[index], "startCheckArr", startCheckArr);
      }
    },
    // 收起按钮点击事件
    closedBtnClick(item, index, tip) {
      if (tip == "售") {
        this.startNodeList[index].isSaleArr = false;
        this.startNodeList[index].isSaleDetails = false;
      } else if (tip == "检") {
        this.startNodeList[index].isCheckArr = false;
        this.startNodeList[index].isCheckDetails = false;
      } else if (tip == "下") {
        this.$set(this.arrivalNodeList[index], "isDownArr", false);
        this.$set(this.arrivalNodeList[index], "isDownDetails", false);
      } else {
        this.$toast("出错");
      }
    },
    // 获取班次下车点
    getArrivalNode() {
      this.isGetArrivalNode = true;
      let params = {
        LineClassDayGID: this.GID,
        ArrivalNodeGroup: this.arrivalNodeGroup,    
      };
      this.$http
        .post(this.$api.getArrivalNode, this.$qs.stringify(params))
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.arrivalNodeList = res.data;
            this.onfilterOrderDetailListOrCheckDetailList(2)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改下车点列表按钮的点击事件
    changeAiivalNodeListBtnClick(item) {
      this.isChangeArrivalNodeListPopup = true;
      this.arrivalChangeInfoList = JSON.parse(JSON.stringify(item));
      this.originArrivalChangeInfoList = JSON.parse(JSON.stringify(item));
    },
    // 确认修改下车点明细
    confirmChangeArrivalNodeList() {
      // const _CompGID = JSON.parse(window.localStorage.getItem("adminInfo")).CompGID;
      let list = JSON.parse(JSON.stringify(this.arrivalChangeInfoList));
      var _jsonText = {};
      _jsonText.GID = list.GID;
      _jsonText.LineClassDayGID = list.LineClassDayGID;
      _jsonText.NodeGID = list.NodeGID;
      _jsonText.IsCanSale = list.IsCanSale;
      _jsonText.Remark = list.Remark;
      _jsonText.IsDeleted = list.IsDeleted;
      _jsonText.ModifyGID = this.OperObj.GID; //操作员GID
      _jsonText.ModifyCode = this.OperObj.UserCode; //操作员代码
      _jsonText.ModifyName = this.OperObj.UserName; //操作员名称
      _jsonText.ModifyTime = new Date();
      _jsonText.CreateGID = list.CreateGID;
      _jsonText.CreateCode = list.CreateCode;
      _jsonText.CreateName = list.CreateName;
      _jsonText.CreateTime = list.CreateTime;
      _jsonText.IsCanAgent = list.IsCanAgent;
      _jsonText.NodeName = list.NodeName;
      _jsonText.RunTime = list.RunTime;
      _jsonText.IsEndNode = list.IsEndNode;
      _jsonText.DownNum = list.DownNum;
      let params = {
        _jsonText: JSON.stringify(_jsonText),
      };
      this.isChangeArrivalNodeListPopup = false;
      this.$http
        .post(this.$api.editLineClassDayArrivalNode, this.$qs.stringify(params))
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$toast("修改成功");
            this.getArrivalNode();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取消修改下车点明细
    cancelChangeArrivalNodeList() {
      this.isChangeArrivalNodeListPopup = false;
    },
    // 下车人数点击事件
    downNumBtnClick(item, index) {
      let saleList = this.ticketOrderDetailList; // 售票明细数据

      let arrivalDownNumArr = [];
      saleList.forEach((data) => {
        if (data.ArrivalNodeGID == item.NodeGID) {
          arrivalDownNumArr.push(data);
        }
      });
      this.$set(
        this.arrivalNodeList[index],
        "arrivalDownNumArr",
        arrivalDownNumArr
      );

      this.$set(this.arrivalNodeList[index], "isDownArr", true);
      this.$set(this.arrivalNodeList[index], "isDownDetails", true);
      console.log(this.arrivalNodeList);
    },
    // 获取班次售票明细
    getTicketOrderDetail() {
      if (this.GID) {
        let params = {
          LineClassDayGID: this.GID,
        };
        this.$http
          .post(this.$api.getTicketOrderDetail, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              this.ticketOrderDetailList = [];
              //过滤掉无效票
              for (let i = 0; i < res.data.length; i++) {
                var item = res.data[i];
                if (item.StatusIsValid) {
                  this.ticketOrderDetailList.push(item);
                  //res.data.splice(i, 1);
                }
              }
              //this.ticketOrderDetailList = res.data;
              let list = this.startNodeList;
              list.forEach((item, index) => {
                this.screenSaleData(item, index, "售");
              });
              this.getTicketCheckDetail(); // 获取检票明细
              this.onfilterOrderDetailListOrCheckDetailList(1)
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$toast("LineClassDayGID" + "为空");
      }
    },
    // 获取班次检票明细
    getTicketCheckDetail() {
      this.isGetTicketCheckDetail = true;
      if (this.GID) {
        let params = {
          LineClassDayGID: this.GID,
        };
        this.$http
          .post(this.$api.getTicketCheckDetail, this.$qs.stringify(params))
          .then((res) => {
            console.log(res);
            if (res.success) {
              this.ticketCheckDetailList = res.data;
              this.ticketCheckDetailList.forEach((item) => {
                switch (item.TicketStatusID) {
                  case 1:
                    item.StatusName = "锁定";
                    break;
                  case 2:
                    item.StatusName = "已售";
                    break;
                  case 3:
                    item.StatusName = "已退";
                    break;
                  case 4:
                    item.StatusName = "已订";
                    break;
                  case 5:
                    item.StatusName = "退订";
                    break;
                  case 6:
                    item.StatusName = "取消";
                    break;
                  case 7:
                    item.StatusName = "已废";
                    break;
                  case 8:
                    item.StatusName = "已检";
                    break;
                  case 9:
                    item.StatusName = "混检";
                    break;
                  case 10:
                    item.StatusName = "手工检";
                    break;
                  case 11:
                    item.StatusName = "已改签";
                    break;
                }
              });
              let list = this.startNodeList;
              list.forEach((item, index) => {
                this.screenSaleData(item, index, "检");
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$toast("LineClassDayGID" + "为空");
      }
    },
    //获取上车点站点分组
    onLineStartNodeNodeGroupNameQuery() {
      debugger
      this.$http
        .post(
          this.$api.onLineStartNodeNodeGroupNameQuery,
          this.$qs.stringify({
            LineGID: this.lineGID,
          })
        )
        .then((res) => {
          if (res.success) {
            this.startNodeGroupList = res.data;
            this.startNodeGroupList.forEach((item) => {
              let needAdd = true;
              this.startNodeActionsGroup.forEach((ng) => {
                if (item.NodeGroup == ng.name) {
                  needAdd = false;
                }
              });
              if (needAdd) {
                this.startNodeActionsGroup.push({
                  name: item.NodeGroup,
                });
              }
            });
          }
        });
    },

    //获取下车点站点分组
    onLineArrivalNodeNodeGroupNameQuery() {
      debugger
      this.$http
        .post(
          this.$api.onLineArrivalNodeNodeGroupNameQuery,
          this.$qs.stringify({
            LineGID: this.lineGID,
          })
        )
        .then((res) => {
          if (res.success) {
            this.arrivalNodeGroupList = res.data;
            this.arrivalNodeGroupList.forEach((item) => {
              let needAdd = true;
              this.arrivalNodeActionsGroup.forEach((ng) => {
                if (item.NodeGroup == ng.name) {
                  needAdd = false;
                }
              });
              if (needAdd) {
                this.arrivalNodeActionsGroup.push({
                  name: item.NodeGroup,
                });
              }
            });
          }
        });
    },

    //上车站点分组选择
    onStartNodeGroupSelect(item) {
      // this.pageNumber = 1;
      // this.total = 0;
      this.selectStartNodeGroup =
        item.name == "取消选择" ? "点击选择上车站点分组" : item.name;
      if (item.name == "取消选择") {
        this.startNodeGroup = "";
        this.getStartNode();
      } else {
        debugger
        this.startNodeGroup = item.name;
        this.getStartNode();
        //this.onfilterOrderDetailListOrCheckDetailList(1);
      }
      this.startNodeShow = false;
    },

    //下车站点分组选择
    onArrivalNodeGroupSelect(item) {
      // this.pageNumber = 1;
      // this.total = 0;
      this.selectArrivalNodeGroup =
        item.name == "取消选择" ? "点击选择下车站点分组" : item.name;
      if (item.name == "取消选择") {
        this.arrivalNodeGroup = "";
        this.getArrivalNode();
      } else {
        this.arrivalNodeGroup = item.name;
        this.getArrivalNode();
        //this.onfilterOrderDetailListOrCheckDetailList(2);
      }
      this.arrivalNodeShow = false;
    },
    onfilterOrderDetailListOrCheckDetailList(flag){
        debugger
        if(flag==1){
        let nodeList = this.startNodeList.map(node=>node.NodeGID); //上车站点数据
        let saleList = this.ticketOrderDetailList; // 售票明细数据
        let checkList = this.ticketCheckDetailList; // 检票明细数据
        //过滤售票明细数据
        this.ticketOrderDetailList = saleList.filter(sale => 
        nodeList.includes(sale.StartNodeGID)
        );

        //检票明细数据
        this.ticketCheckDetailList = checkList.filter(sale => 
        nodeList.includes(sale.StartNodeGID)
        );

        }
        else if(flag==2){
        let nodeList = this.arrivalNodeList.map(node=>node.NodeGID); //上车站点数据
        let saleList = this.ticketOrderDetailList; // 售票明细数据
        let checkList = this.ticketCheckDetailList; // 检票明细数据
        //过滤售票明细数据
        this.ticketOrderDetailList = saleList.filter(sale => 
        nodeList.includes(sale.ArrivalNodeGID)
        );

        //检票明细数据
        this.ticketCheckDetailList = checkList.filter(sale => 
        nodeList.includes(sale.ArrivalNodeGID)
        );
        }

    }

  },
  watch: {
    active(val) {
      debugger
      if(val == 0){
        this.startNodeGroup = "";
        this.selectStartNodeGroup ="点击选择上车站点分组",
        this.getStartNode();
      }else{
        this.startNodeGroup = "";
        this.selectStartNodeGroup ="点击选择上车站点分组",
        this.getStartNode();
        this.arrivalNodeGroup = "";
        this.selectArrivalNodeGroup= "点击选择下车站点分组",
        this.getArrivalNode();
      }
      if (val == 1 && !this.isGetArrivalNode) {
        this.getArrivalNode();
      }
    },
    isChangeStartNodeListPopup(val) {
      if (!val) {
        this.changeInfoList = this.originChangeInfoList;
      }
    },
    isChangeArrivalNodeListPopup(val) {
      if (!val) {
        this.arrivalChangeInfoList = this.originArrivalChangeInfoList;
      }
    },
  },
  mounted() {
    if(!this.GID){
      window.location.replace(location.origin+location.pathname)
      return;
    }
    this.getStartNode();
    this.onLineStartNodeNodeGroupNameQuery();
    this.onLineArrivalNodeNodeGroupNameQuery();
  },
};
</script>

<style scoped lang="less">
.LineClassListDetail /deep/ .van-tabs {
  z-index: 0;
}

.LineClassListDetail {
  width: 100%;
  height: auto;
  font-size: 0.4rem;

  >.header {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    display: flex;
    justify-content: space-around;
    padding: 0 0.2rem;
    box-sizing: border-box;
    color: #333;

    span {
      flex: 1;
      text-align: center;
    }
  }

  .Node {
    width: 100%;
    height: auto;

    >.NodeTotal {
      width: 100%;
      height: auto;

      >.title {
        position: relative;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        background-color: #999;
        color: #fff;
        font-size: 0.44rem;
        font-weight: 700;

        >.van-switch {
          position: absolute;
          right: 0.2rem;
          top: 0.22rem;
        }
      }

      >.content {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        >.wrap {
          width: 100%;
          height: auto;

          >.node {
            width: 100%;
            height: auto;
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #eee;
            border-bottom: 1px solid rgb(40, 145, 231);

            .btn {
              padding: 0.1rem 0.2rem;
              box-sizing: border-box;

              button {
                width: 100%;
                height: 100%;
                border-radius: 0.08rem;
                background-color: #2891e7;
                color: #fff;
              }
            }

            span {
              flex: 1;
              height: auto;
              padding: 0.2rem 0.1rem;
              text-align: center;
              background-color: #fff;
              overflow: hidden;
              -ms-text-overflow: ellipsis;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            span:first-child {
              flex: 1;
              border-right: 0.02rem solid #2891e7;
            }

            span:nth-child(2) {
              border-right: 0.02rem solid #2891e7;
            }

            span:nth-child(2).current {
              color: #fff;
              background-color: #8fcdff;
            }

            span:nth-child(3).current {
              color: #fff;
              background-color: #67c23a;
            }

            span:nth-child(3) {
              border-right: 0.02rem solid #2891e7;
            }
          }

          >.detailHeader {
            width: 100%;
            height: auto;
            display: flex;
            justify-content: space-between;

            span {
              flex: 1;
              height: auto;
              padding: 0.2rem 0.1rem;
            }

            span:first-child {
              flex: 2;
            }

            span:nth-child(2) {
              flex: 1.5;
            }

            span:nth-child(3) {
              flex: 1;
            }
          }

          >.detail {
            width: 100%;
            height: auto;
            background-color: #fff;

            >div {
              display: flex;
              justify-content: space-between;

              >span {
                flex: 1;
                height: auto;
                line-height: 0.6rem;
                padding: 0.2rem 0.1rem;
                text-align: center;
                background-color: #8fcdff;
                color: #fff;
              }

              >span:first-child {
                flex: 2;
                border-right: 0.02rem solid #fff;
                padding: 0.2rem;
              }

              >span:nth-child(2) {
                flex: 1.5;
                border-right: 0.02rem solid #fff;
                padding: 0.2rem;
              }

              >span:nth-child(3) {
                flex: 1;
              }
            }

            >.noData {
              display: block;
              text-align: center;
              background-color: #eee;
            }

            >.closed {
              display: block;
              background-color: #eee;
              padding: 0.1rem 0;
              overflow: hidden;

              >span {
                display: inline-block;
                background-color: #fff;
                color: #999;
                border: 1px solid #ccc;
                box-sizing: border-box;
                padding: 0.1rem 0.3rem;
                border-radius: 0.1rem;
                margin-top: 0.1rem;
              }
            }
          }

          >.checkDetail {
            >div {
              >span {
                background-color: #67c23a;
                color: #fff;
              }
            }
          }
        }
      }
    }

    >.ArrivalNode {
      >.content {
        >.wrap {
          >.node {
            span:nth-child(3) {
              border-right: none;
            }
          }
        }
      }
    }
  }

  .ClassDetail {
    width: 100%;
    height: auto;

    >.detail {
      width: 100%;
      height: auto;

      >.title {
        display: flex;
        justify-content: space-between;

        span {
          flex: 1;
          height: auto;
          padding: 0.2rem 0.1rem;
          text-align: center;
        }

        span:nth-child(1) {
          flex: 1;
          text-align: right;
        }

        span:nth-child(2) {
          flex: 2;
          text-align: right;
        }
      }

      >.content {
        width: 100%;
        height: auto;

        >.wrap {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-between;

          span {
            flex: 1.4;
            height: auto;
            padding: 0.2rem 0.1rem;
            text-align: center;
            background-color: #fff;
            color: #666;
            border-bottom: 0.04rem solid #ccc;
            border-right: 0.04rem solid #ccc;
          }

          span:nth-child(1) {
            flex: 2;
          }

          span:nth-child(2) {
            flex: 2;
          }

          span:nth-child(4) {
            border-right: 0;
          }
        }
      }
    }
  }

  .isChangeNodeListPopup {
    width: 80vw;
    height: 80vh;
    background-color: transparent;

    .header {
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      border-bottom: 0.02rem solid #ccc;
      background-color: #2891e7;
      color: #fff;
    }

    .wrap {
      width: 100%;
      height: 60vh;
      overflow: scroll;

      .row {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        border-bottom: 0.02rem solid #ccc;
        display: flex;
        justify-content: space-between;
        padding: 0 0.2rem;
        box-sizing: border-box;
        background-color: #fff;

        span:nth-child(1) {
          width: 3rem;
          text-align: left;
        }

        span:nth-child(2) {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: right;

          input[type="checkbox"] {
            width: 0.6rem;
            height: 0.6rem;
            margin-top: 0.2rem;
          }

          input[type="text"] {
            width: calc(100% - 0.1rem);
            height: 0.6rem;
            border: 0.02rem solid #ccc;
            padding: 0 0.1rem;
            box-sizing: border-box;
          }
        }
      }
    }

    .btn {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;

      .confirm {
        flex: 1;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #2891e7;
        color: #fff;
      }

      .cancel {
        flex: 1;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background-color: #999;
        color: #fff;
      }
    }
  }
}

.isCanSale {
  display: inline-block;
  background: red;
  color: white;
  padding: 0.05rem 0.2rem;
  position: absolute;
  left: 1.6rem;
  top: 0;
  z-index: 999;
  font-size: 0.2rem;
}
</style>